import { Match } from '@repo/types';

export type Tournament = {
  id: string;
  name: string;
  matches: Match[];
};

export enum ClubNameType {
  ThreeLetterName = 'threeLetterName',
  ShortName = 'shortName',
  FullName = 'fullName',
  NickName = 'nickName',
}

export type TournamentSummaryT = Omit<Tournament, 'matches'>;
